import React from 'react';
import styled from 'styled-components';
import { createSelectorHook } from 'react-redux';

const Link = styled.a`
  cursor: pointer;
  color: ${({ theme }) => theme.colors.institucional};
  text-decoration: none;
  font-size: 16px;
  font-weight: bold;

  &:hover {
    text-decoration: underline;
  }
`;

type RootState = {
  user: {
    id: number;
    name: string;
    cpf: string;
    email: string;
    firstAccess: boolean;
    firstDashboardAccess: boolean;
    cookieConsent: boolean;
    termoUsoUsuario: {
      linkTermoUso: string;
      linkPoliticaPrivacidade: string;
      dataLimiteAceite: string;
      intervaloNotificaUsuario: number;
      flagStatusAceite: boolean;
      dataAtualizacaoTermo: string;
    };
  };
};

export default function Links() {
  const useSelector = createSelectorHook<RootState>();
  const terms = useSelector(state => state?.user?.termoUsoUsuario);

  return (
    <>
      <Link href={terms?.linkTermoUso} target="_blank">
        Termos de Uso
      </Link>{' '}
      e{' '}
      <Link href={terms?.linkPoliticaPrivacidade} target="_blank">
        Política de Privacidade
      </Link>
    </>
  );
}
